module.exports = __webpack_public_path__ + "static/media/background2.c945fadf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bg/background2.jpg
// module id = 407
// module chunks = 0